<template>
    <div class="error-container">
      <!-- <div class="login-header">
        <div class="login"></div>
      </div> -->
      <el-form class="error-form gsForm" :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="110px">
        <h3 class="title">{{$t("custom_lang_0100")}}</h3>
        <h4 class="p20 texLine">{{$t("custom_lang_0101")}}</h4>
        <!--<div class="el-error__body">-->
          <!--<div class="el-error__bd">-->
        <el-form-item :label="$i18n.t('custom_lang_0102')">
          <el-input v-model="ruleForm.phoneBound" :disabled="true"></el-input>
          <el-button @click.native="startCountdown" :disabled="countdown > 0"><span v-show="countdown > 0">{{countdown}}{{$t("custom_lang_0129")}}</span><span v-show="countdown <= 0">{{$t("custom_lang_0103")}}</span></el-button>
        </el-form-item>
        <el-form-item :label="$i18n.t('custom_lang_0104')" prop="verifyCode">
          <el-input v-model="ruleForm.verifyCode" autocomplete="off" :placeholder="$i18n.t('custom_lang_0125')" maxlength="6"></el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="ruleForm.sameBrowser">{{$t("custom_lang_0106")}}</el-checkbox>
        </el-form-item>
        <el-form-item class="pt20">
          <el-button type="primary" @click="submitForm('ruleForm')">{{$t("custom_lang_0033")}}</el-button>
          <!--<el-button @click="resetForm('ruleForm')">{{$t("wm_lang_html_4b9c32")}}</el-button>-->
          <!--<el-button type="primary" @click.native.prevent="goBack">{{$t("wm_lang_html_5f4112")}}</el-button>-->
          <!-- <el-button @click.native.prevent="goSkip" v-show='skipBtn'>{{$t("wm_lang_html_92636e")}}</el-button> -->
        </el-form-item>
          <!--</div>-->
        <!--</div>-->
      </el-form>

    </div>
</template>

<script>
  import xmail from '@/api/api';
  import storeLocal from 'store';
  import Cookies from 'js-cookie';
    export default {
      components: { },
      name: 'SecondVerify',
      data() {
        let validateCode = (rule, value, callback) => {
          if (value === '') {
            callback(new Error(this.$i18n.t('custom_lang_0105')));
          } else {
            const regex = /^\d+$/;
            if(!regex.test(value) || value.length !== 6) {
              callback(new Error(this.$i18n.t('custom_lang_0109')));
            } else {
              callback();
            }
          }
        };
        return {
          ruleForm: {
            phoneBound: '',
            phoneBoundSend: '',
            verifyCode: '',
            sameBrowser: true
          },
          countdown: 0,
          timerId: null,
          rules: {
            verifyCode: [
              { validator: validateCode, trigger: 'blur' }
            ]
          },
          skipBtn: false
        };
      },
      computed: {
        //
      },
      methods: {
        // goBack() {
        //   this.$router.push({ path: '/' });
        // },
        // goSkip() {
        //   this.$router.push({ path: '/' });
        // },
        submitForm(formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              let self = this;
              (function (api, enums, pms) {
                let pm = pms.UnActiveAccount.verifySecureLoginParamBuilder();
                pm.code = self.ruleForm.verifyCode;
                pm.mobile = self.ruleForm.phoneBoundSend;
                pm.skipCheckCode = self.ruleForm.sameBrowser;
                api.UnActiveAccount.verifySecureLogin(pm, function (res) {
                  // console.log(res)
                  if(res.data.code === 0) {
                    //该接口返回的数据信息无法给全，用userPwdLogin登录接口的数据
                    storeLocal.set('Pwm-Islogin', self.errorData.data.sid);
                    storeLocal.set('Pwm-userInfo', self.errorData.data);
                    // 后端请求的URL参数用主域名账号
                    storeLocal.set('Pwm-urlParams', '?sid='+ self.errorData.data.sid +'&loginAppType='+ self.errorData.data.loginAppType +'&user='+self.errorData.data.primeUserEmail);
                    self.$store.commit('SET_USER', self.errorData.data.userEmail);
                    storeLocal.set('Pwm-secondVerify', true);

                    if(self.errorData.data.modifyPwdCycle || self.errorData.data.modifyPwdFirst || self.errorData.data.modifyPwdWeak) {
                      storeLocal.remove('Pwm-Islogin');
                      storeLocal.remove('Pwm-user');
                      storeLocal.remove('Pwm-password');
                      let pwTypeCode = '';
                      if(self.errorData.data.modifyPwdCycle) {
                        pwTypeCode = xmail.enums.ErrorCode.UDR_USER_PASSWORD_CYCLE_ERROR;
                      }
                      if(self.errorData.data.modifyPwdFirst) {
                        pwTypeCode = xmail.enums.ErrorCode.UDR_USER_PASSWORD_FIRST_ERROR;
                      }
                      if(self.errorData.data.modifyPwdWeak) {
                        pwTypeCode = xmail.enums.ErrorCode.WM_PASSWORD_WEAK_ERROR;
                      }
                      storeLocal.set('Pwm-passwordRule', {...self.errorData.data.corpRulePasswd,...{pwType:pwTypeCode}});
                      self.$router.push({name: 'ChangePw', params: { errorData: self.errorData}});
                    } else {
                      // let self = this;
                      // (function (api, enums, pms) {
                      //   api.Home.homeSetting({}, function (res) {
                      //     if(res.data.code === 0) {
                      //       // console.log(res.data.data)
                      //       window.document.title = res.data.data.displaySetting.customTitle ? res.data.data.displaySetting.customTitle : this.$i18n.t('wm_lang_d7c0a1');
                      //       let configSetting = storeLocal.get('Pwm-configSetting');
                      //       if(configSetting) {//多语言强制刷新
                      //         if(res.data.data.displaySetting.language !== configSetting.displaySetting.language) {
                      //           storeLocal.set('Pwm-configSetting', res.data.data);
                      //           window.location.href = window.location.protocol + "//" + window.location.host;
                      //         }
                      //       }
                      //       storeLocal.set('Pwm-configSetting', res.data.data);
                      //       if(res.data.data.displaySetting.layout === enums.Layout.LR) {
                      //         Cookies.set('Pwm-set-layout','lr');
                      //       } else {
                      //         Cookies.set('Pwm-set-layout','tb');
                      //       }
                      //       //layout初始化
                      //       // self.initPage();
                      //       //文件夹初始化
                      //       self.$EventBus.$emit("getInitFolder");
                      //       //首页初始化
                      //       self.$EventBus.$emit("getInitHome");
                      //       //页头初始化
                      //       self.$EventBus.$emit("getInitHeader");
                      //
                      //       self.$router.push({ path: '/' });
                      //     }
                      //   })
                      // })(xmail.api, xmail.enums, xmail.pms);

                      self.$router.push({ path: '/' });
                      // self.$router.push({name: 'Error', query: {code:data.code, host:data.host, time:data.time, traceId:data.traceId , webLanguage:data.data ? data.data.webLanguage : '' }});
                    }
                    storeLocal.remove('Pwm-secondVerify-errorData');
                  } else {
                    // self.$message({
                    //   type: 'error',
                    //   message: '二次验证失败'
                    // });
                  }
                })
              })(xmail.api, xmail.enums, xmail.pms);
            } else {
              console.log('error submit!!');
              return false;
            }
          });
        },
        startCountdown() {
          this.countdown = 60;
          this.timerId = setInterval(() => {
            this.countdown--;
            if (this.countdown <= 0) {
              clearInterval(this.timerId);
            }
          }, 1000);
          this.sendSmsCode();
        },
        sendSmsCode() {
          // console.log('发送获取验证码的请求');
          // 发送验证码的逻辑
          let self = this;
          (function (api, enums, pms) {
            let pm = {mobile: self.ruleForm.phoneBoundSend,templateType: enums.NoticeTemplateType.SAFE_LOGIN};
            api.UnActiveAccount.sendCode(pm, function (res) {
              if(res.data.code === 0) {
                self.$message({
                  type: 'success',
                  message: self.$i18n.t('custom_lang_0108')
                });
              } else if(res.data.code === enums.ErrorCode.NOTIFIER_CODE_LIMIT_ERROR) {
                self.countdown = 30;
              }
            })
          })(xmail.api, xmail.enums, xmail.pms);
        },
        hideMiddleFourDigits(phoneNumber) {
          if (phoneNumber.length !== 11) {
            return "Invalid phone number length";
          }
          // 确保只包含数字
          if (!phoneNumber.match(/^[0-9]+$/)) {
            return "Invalid phone number format";
          }
          const hidden = phoneNumber.replace(/(.{3})(.{4})(.{3})/, '$1****$3');
          return hidden;
        },
        keyupSubmit() {
          document.onkeyup = (e) => {
            let _key = window.event.keyCode;
            if (_key === 13) {
              this.submitForm('ruleForm');
            }
          };
        },
        resetForm(formName) {
          this.$refs[formName].resetFields();
        }
      },
      mounted() {
        // console.log(this.$route.params);
        if(!(Object.keys(this.$route.params).length === 0)) {
          storeLocal.set('Pwm-secondVerify-errorData',this.$route.params.errorData);
        }
        this.errorData = !(Object.keys(this.$route.params).length === 0) ? this.$route.params.errorData : storeLocal.get('Pwm-secondVerify-errorData');

        // this.ruleForm.phoneBound = this.errorData.data.bindInfo.bindId;
        this.ruleForm.phoneBoundSend = this.errorData.data.bindInfo.bindId;
        this.ruleForm.phoneBound = this.hideMiddleFourDigits(this.errorData.data.bindInfo.bindId);

        //强制刷新多语言
        // let configSetting = storeLocal.get('Pwm-configSetting');
        // if(configSetting) {
        //   if(this.$route.params.errorData.data.webLanguage && this.$route.params.errorData.data.webLanguage !== configSetting.displaySetting.language) {
        //     configSetting.displaySetting.language = this.$route.params.errorData.data.webLanguage;
        //     storeLocal.set('Pwm-configSetting', configSetting);
        //     location.reload()
        //   }
        // }
      },
      created() {
        this.keyupSubmit();
      },
      destroyed() {
        //
      }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .error-container {
    position: relative;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
    // background-color: #0661E4;
    .texLine{border-bottom: 1px solid #eee; margin-bottom: 30px}
  }
  .title {
      font-size: 16px;
      font-weight: 400;
      background: #3986ee;
      color: #fff;
      margin: 0 auto;
      text-align: left;
      padding: 12px 20px!important;
  }
  .error-form {
    position: absolute;
    left: 0;
    right: 0;
    width: 840px;
    margin: 0 auto;
    margin-top: 20vh;
    box-shadow: 0px 8px 16px -8px rgba(0,0,0,0.16), 0px 12px 32px 0px rgba(0,0,0,0.12), 0px 16px 48px 16px rgba(0,0,0,0.08), 0px 8px 16px -8px rgba(0,0,0,0.16), 0px 12px 32px 0px rgba(0,0,0,0.12), 0px 16px 48px 16px rgba(0,0,0,0.08);border-radius: 0px!important;border:none!important;
    background:#fff;
  }
  .el-error__body{
    padding: 20px;
    overflow: hidden;
    .el-error__bd{width:100%;}
    .note-box{line-height:21px;padding-top:20px;}
    }
  .error-form .el-input{
    margin-right: 10px;
    width: 270px;
    vertical-align: top;
  }
  .error-form .codeBtn{
    width: 120px;
  }
  /*.login-header{*/
      /*height:102px;*/
      /*width:90%;*/
      /*position:fixed;*/
      /*top:0;*/
      /*left:5%;*/
      /*.login{background-image: url('~@/assets/images/logo_pic.png');background-size:80%;background-repeat: no-repeat;height:73px;width:194px;margin-top:30px;}*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/components/views/login/secondVerify.vue